import { Badge } from './ui';

export interface QualityScoresShape {
  quality?: number;
  readability?: number;
  hasCta?: boolean;
  note?: string;
}

function toneFor(score: number): 'success' | 'warning' | 'danger' {
  if (score >= 0.7) return 'success';
  if (score >= 0.4) return 'warning';
  return 'danger';
}

/** Renders stored quality scores (variant.metadata.quality) as badges. */
export function QualityScores({ scores }: { scores?: QualityScoresShape }) {
  if (!scores) return null;
  const hasAny = scores.quality != null || scores.readability != null || scores.hasCta != null;
  if (!hasAny) return null;
  return (
    <div className="pill-list" style={{ marginTop: 6 }}>
      {scores.quality != null && <Badge tone={toneFor(scores.quality)}>quality {Math.round(scores.quality * 100)}%</Badge>}
      {scores.readability != null && <Badge tone="info">readability {Math.round(scores.readability * 100)}%</Badge>}
      {scores.hasCta != null && <Badge tone={scores.hasCta ? 'success' : 'danger'}>{scores.hasCta ? 'CTA ok' : 'no CTA'}</Badge>}
      {typeof scores.note === 'string' && scores.note && <span className="muted" style={{ fontSize: 11 }}>{scores.note}</span>}
    </div>
  );
}